<kendo-label text="Operation Status">
    <kendo-multiselect [data]="travelStatuses"
                       [disabled]="isDisabled"
                       [value]="value"
                       (valueChange)="handleValueChange($event)"
                       (blur)="handleBlur()"
                       textField="name"
                       valueField="value"
                       [valuePrimitive]="true">
    </kendo-multiselect>
</kendo-label>
